<template>
	<div>
		<slot :core="this"></slot>
	</div>
</template>

<script>
	import loading from '@/mixins/view-module';

	export default {
		props: {
			reportObj: {
				type: Object,
			},
		},
		/**
		 * 注意这里混入了loading辅助函数,刷新分页时会自动调用loading
		 * 如果想要加入loading效果,子组件必须将core.elLoading加入v-loading指令中
		 * 顺带一提,如果子组件想要避开pageStateChange的自动流程,而希望手动唤起loading流程
		 * 可以使用core.setElLoading函数而不是唤起pageStateChange事件
		 */
		mixins: [loading],
		provide() {
			return {
				core: this,
				/**report回调,需要ui组件主动调用以启动分页功能 */
				report: (obj) => {
					this.report = obj;
					this.aftReport();
				},
				reportFilter: function(sort = 0) {
					//由于过滤器总数不会很多,在自动模式下直接调用while循环寻找未赋值的过滤器槽位
					//注意复杂度为n^2,如果真的要使用很多过滤器,建议在组件内指明sort
					while (this.filters[sort] !== undefined) {
						sort++;
					}
					this.filters[sort] = [];
					return sort;
				}.bind(this),
				setFilter: function(index, filter = []) {
					this.filters[index] = filter;
					this.filterChange = true;
					this.pageStateChange();
				}.bind(this),
				getFilter: function(index) {
					return this.filters[index];
				}.bind(this),
				/**
				 * 扩展事件链,子组件将有机会监听到列表的核心事件
				 * key为防止重复添加所做的标记;
				 * fn为无参回调;
				 * field为事件链字段,见data说明,缺省则应用到所有事件链;
				 * overwrite表示冲突时采用覆盖(true)还是采用跳过(false)
				 */
				addEvent: function(key, fn, field, overwrite = true) {
					if (field) {
						this[field].has(key) || !overwrite || this[field].set(key, fn);
					} else {
						this.pageStateChain.has(fn) || !overwrite || this.pageStateChain.set(key, fn);
						this.refreshChain.has(fn) || !overwrite || this.refreshChain.set(key, fn);
					}
				}.bind(this),
			};
		},
		data() {
			return {
				/**
				 * 传给分页组件的响应式变量,已遵守变量约定
				 */
				pagination: null,
				/**子组件回报列表 */
				report: null,
				/**
				 * 过滤器列表,这里按数字序号保存了所有过滤器,如有需要可以利用此对象获取
				 * 但是注意修改必须在副本上进行,否则会影响到当前的分类
				 */
				filters: {
					[Symbol.iterator]: function*() {
						for (let i = 0; this[i] !== undefined; i++) {
							yield this[i];
						}
					},
				},
				/**经过mergeFilter整合的filters,传入refresh的是经过整合的filter而非原始值 */
				filterOption: undefined,
				/**变化标志,防止没变化也多次调用mergeFilter */
				filterChange: false,
				/**分页信息变化事件链,用于支持macro回调 */
				pageStateChain: new Map(),
				/**主动刷新事件链,用于支持macro回调 */
				refreshChain: new Map(),
			};
		},
		beforeMount() {
			if (this.reportObj instanceof Object) {
				this.report = this.reportObj;
				this.aftReport();
			}
		},
		computed: {
			/**用于后台请求的获取分页信息参数 */
			pageStateForReq() {
				return {
					page: this.pagination.currentPage,
					limit: this.pagination.pageSize,
				};
			},
		},
		methods: {
			/**唤起事件链,field为事件链字段,目前pageStateChange函数和refresh函数分别有一个事件链 */
			startEventChain(field) {
				this[field].forEach((v) => v());
			},
			/**初始化函数,由子组件的回报操作触发 */
			aftReport() {
				this.pagination = this.report.pageSource();
			},
			/**对外接口,分页信息变化事件,允许设置页数后再刷新 */
			pageStateChange(page) {
				this.startEventChain('pageStateChain');

				if (typeof page === 'number') {
					this.pagination.currentPage = page;
				}
				this.setElLoading(this.refresh());
			},
			/**对外接口,主动刷新数据,但不设置loading标志,子组件有这方面需求时使用 */
			refresh() {
				this.startEventChain('refreshChain');

				if (this.filterChange) {
					this.pagination.currentPage = 1;
					this.filterOption = this.report.mergeFilter(this.filters);
					this.filterChange = false;
				}
				return this.report.refresh(this.pageStateForReq, this.filterOption);
			},
		},
	};
</script>
